import React from 'react';
import { useSearchContext } from './SearchContext';

function UVACollection() {
    const { buildLink } = useSearchContext();
    
    return (
        <div>
            <div class="row">
                <h1 class="page-header">The University of Virginia Collection</h1>
                <p>University of Virginia Discard Notice:</p>
                <p>"SPECIAL COLLECTIONS: The following photocopies/photographic copies of Brown documents were discarded 11/30/2005 because we were unable to identify institution(s) holding the original documents and because many of the photocopies were mutilated: Loan office book pages; </p>
                <p>1786 Jul.6-1784 Mar. Pasyunk farm accounts; </p>
                <p>1783 poem about Columbus; 1783 page from Liberty of Conscience; </p>
                <p>1786 May 11 Poems on several occasions; </p>
                <p>1786 AMs by Charles Brown, age 16; </p>
                <p>1786 page from his first essay;</p>
                <p> 1793  Apr.22; [post 1793], Brown's copy of An enquiry concerning political influence; [ca.1801[ miscellaneous notes and poetry; </p>
                <p>1801 Mar. 9; 1801 Oct. 12; 1803 Mar. 16; 1803 Sep. 19; 1807 Aug. 1; 1807 Aug. 3; 1807 Sep. 1; 1810l family Bible records; 1826 June 22; 1836 Apr. 4; 1840 Jun. 29; 1842 Jan.1; 1845 July 1; 1847 Sep. 6; 1847 Sep. 19; 1848 Mar. 5; n.d. A receipt to cure the stone; n.d. notes for Weiland; n.d., list of words; n.d., A dialogue on acquiring knowledge; n.d., miscellaneous notes; n.d.notes for a novel; n.d., Will this be sufficient by way of exercise?; n.d. page beginning "with great courage"; n.d., "From the New York paper ..." ; n.d., "Authors, ancient and modern ..."; n.d., "the reformation of religion ..."; n.d., poems to Della Crusca; n.d., a poem; n.d. ALS to Joseph and James; n.d., ALS, Elijah? Brown; n.d., unidentified mss pages. </p>
                <p>SPECIAL COLLECTIONS: 2 boxes, Vault - Barrett- Brown </p>
                <p>SPECIAL COLLECTIONS: OS box L-5 -oversize items Marcive"</p>

                <p>
                    Click here to access the{' '}
                    <a href={buildLink('/uva-bibliography')}>University of Virginia Special Collections Accession List pre-2005</a>{' '}
                    and <a href={buildLink('/uva-manuscripts')}>the manuscript reproductions</a>.
                </p>
            </div>

        </div>
    );
}

export default UVACollection;
